/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEgNC42MUg0LjYxVjFINS42MVY1LjYxSDFWNC42MVpNNC42MSAxMS4zOUgxVjEwLjM5SDUuNjFWMTVINC42MVYxMS4zOVpNMTEuMzkgNC42MVYxSDEwLjM5VjUuNjFIMTVWNC42MUgxMS4zOVpNMTEuMzkgMTVIMTAuMzlWMTAuMzlIMTVWMTEuMzlIMTEuMzlWMTVaIiBmaWxsPSJpbmhlcml0Ii8+PC9zdmc+";